import Customupload from '../../components/UploadFile'
import styles from './style.module.scss'
import { Button, Col, Row } from 'antd'
import { Accept } from '../../tools/util'
import { UploadOutlined } from '@ant-design/icons'
import CustomIcon from '../../components/IconUser'
import useHook, { Props } from './hooks'
import PreviewModal from '../../components/previewModal'
import { forwardRef } from 'react'
// 上传文件
const Uploadfiles = forwardRef((props: Props, ref?: React.Ref<HTMLElement>) => {
  const {
    disabled,
    title,
    accept,
    maxCount = 9999,
    canNotUploadEvent,
    hiddenDownload,
    NoUploadButton,
    disabledDel,
    uploadBtnStyle,
  } = props
  const {
    previewFileUrl,
    isPreviewModalVisible,
    showPreviewModal,
    cancelPreviewModal,
    beforeUpload,
    onClickDel,
    onClickDown,
    dataSource,
  } = useHook(props)

  return (
    <div>
      <div hidden={(dataSource?.length ?? 0) >= maxCount}>
        <Customupload
          accept={accept || Accept('file')}
          disabledUpload={disabled}
          uploadBtn={
            <Button
              disabled={disabled}
              type="default"
              size="small"
              ref={ref}
              style={uploadBtnStyle || { margin: '0 0 10px 0' }}
              onClick={canNotUploadEvent}
            >
              &nbsp;&nbsp;{title ? title : '上传文件'}
              <UploadOutlined />
            </Button>
          }
          beforeUpload={beforeUpload}
          visibleFile={false}
          multiple={false}
          openFileDialogOnClick={canNotUploadEvent ? false : true}
          NoUploadButton={NoUploadButton}
        />
      </div>
      <div className={styles.filebox}>
        <Row>
          {dataSource?.map((item) => (
            <Col key={item.url}>
              <div className={styles.fileitem}>
                <CustomIcon type="icon-wenjian1" style={{ fontSize: '20px' }} />
                <span
                  style={{
                    cursor: 'pointer',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    maxWidth: '140px',
                  }}
                  onClick={() => showPreviewModal(item)}
                  title={item?.name}
                >
                  {item?.name}
                </span>
                {disabled !== true && !disabledDel ? (
                  <CustomIcon
                    type="icon-shanchu1"
                    onClick={() => onClickDel(item)}
                    className={styles.delicon}
                  />
                ) : null}
                {!hiddenDownload && (
                  <Button
                    size="small"
                    type="link"
                    style={{ fontSize: '12px' }}
                    onClick={() => onClickDown(item)}
                  >
                    下载
                  </Button>
                )}
              </div>
            </Col>
          ))}
        </Row>
      </div>
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      ></PreviewModal>
    </div>
  )
})

export default Uploadfiles
import Customupload from '../../components/UploadFile'
import styles from './style.module.scss'
import { Button, Col, Row } from 'antd'
import { Accept } from '../../tools/util'
import { UploadOutlined } from '@ant-design/icons'
import CustomIcon from '../../components/IconUser'
import useHook, { Props } from './hooks'
import PreviewModal from '../../components/previewModal'
import { forwardRef } from 'react'
// 上传文件
const Uploadfiles = forwardRef((props: Props, ref?: React.Ref<HTMLElement>) => {
  const {
    disabled,
    title,
    accept,
    maxCount = 9999,
    canNotUploadEvent,
    hiddenDownload,
    NoUploadButton,
    disabledDel,
    uploadBtnStyle,
  } = props
  const {
    previewFileUrl,
    isPreviewModalVisible,
    showPreviewModal,
    cancelPreviewModal,
    beforeUpload,
    onClickDel,
    onClickDown,
    dataSource,
  } = useHook(props)

  return (
    <div>
      <div hidden={(dataSource?.length ?? 0) >= maxCount}>
        <Customupload
          accept={accept || Accept('file')}
          disabledUpload={disabled}
          uploadBtn={
            <Button
              disabled={disabled}
              type="default"
              size="small"
              ref={ref}
              style={uploadBtnStyle || { margin: '0 0 10px 0' }}
              onClick={canNotUploadEvent}
            >
              &nbsp;&nbsp;{title ? title : '上传文件'}
              <UploadOutlined />
            </Button>
          }
          beforeUpload={beforeUpload}
          visibleFile={false}
          multiple={false}
          openFileDialogOnClick={canNotUploadEvent ? false : true}
          NoUploadButton={NoUploadButton}
        />
      </div>
      <div className={styles.filebox}>
        <Row>
          {dataSource?.map((item) => (
            <Col key={item.url}>
              <div className={styles.fileitem}>
                <CustomIcon type="icon-wenjian1" style={{ fontSize: '20px' }} />
                <span
                  style={{
                    cursor: 'pointer',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    maxWidth: '140px',
                  }}
                  onClick={() => showPreviewModal(item)}
                  title={item?.name}
                >
                  {item?.name}
                </span>
                {disabled !== true && !disabledDel ? (
                  <CustomIcon
                    type="icon-shanchu1"
                    onClick={() => onClickDel(item)}
                    className={styles.delicon}
                  />
                ) : null}
                {!hiddenDownload && (
                  <Button
                    size="small"
                    type="link"
                    style={{ fontSize: '12px' }}
                    onClick={() => onClickDown(item)}
                  >
                    下载
                  </Button>
                )}
              </div>
            </Col>
          ))}
        </Row>
      </div>
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
      ></PreviewModal>
    </div>
  )
})

export default Uploadfiles
